const AnaesthetictechnicianStaff = [
  {
    name: "Dr. Pamela. O. Agbamu",
    qualification:"MBBS, DA, FWACS, Obstetric Anaesthesia,Fellow Tel-Aviv, Israel",
    designation: "Coordinator",
    photo: "",
  },
  {
    name: "Dr. Alero. J. Ofuase",
    qualification:"MBBS, DA, FMCA",
    designation: "Deputy Coordinator/Lecturer",
    photo: "",
  },
   {
    name: "Dr. Niyi Adesida",
    qualification:"MBBS, DA, FMCA",
    designation: "Lecturer",
    photo: "",
  },
   {
    name: "Dr. Muyiwa Rotimi",
    qualification:"MBBS, DA, FWACS",
    designation: "Lecturer",
    photo: "",
  },
   {
    name: "Dr. Kolawole Asiyanbi",
    qualification:"lecturer",
    designation: "MBBS, DA, FWACS",
    photo: "",
  },
{
    name: "Dr. Ijeoma. C. Ohagwu",
    qualification:"MBBS, FWACS Paediatric Anaesthetist",
    designation: "Lecturer",
    photo: "",
  },
  {
    name: "Dr. Uzoma. C. Ifezue",
    qualification:"MBBS, DA, FWACS",
    designation: "Lecturer",
    photo: "",
  },
  {
    name: "Prof. Ibironke Desalu",
    qualification:"MBBS, DA, FWACS, FMCA, FMCEM",
    designation: "School Advisory Board",
    photo: "",
  }, 
{
    name: "Associate Prof. J. Olatosi",
    qualification:"MBBS, DA,FWACS, FNAMed",
    designation: "School Advisory Board",
    photo: "",
  }, 
  {
    name: "Prof. Oyebola Adekola",
    qualification:"MBBS, DA, MSc, FWACS,FMCA",
    designation: "School Advisory Board",
    photo: "",
  }, 
   {
    name: "Dr. Gbolahan Abioyes",
    qualification:"MBBS, DA, FMCA",
    designation: "Lecturer",
    photo: "",
  }, 
]

export default AnaesthetictechnicianStaff;